<template>
  <v-dialog
    :model-value="open"
    class="gps_modal-dialog"
    content-class="gps_modal"
    persistent
    scrollable
    :scrim="'#212121'"
    :opacity="0.65"
    @update:model-value="handleDialogUpdate"
  >
    <pin-pad
      :item="item"
      :pinNumber="pinNumber"
      :validationErrors="validationErrors"
      v-bind="$attrs"
      @backspace-pin="backspacePin"
      @close-modal="$emit('close-modal', $event)"
      @redeem="$emit('redeem', $event)"
      @update-pin="updatePin"
    />
  </v-dialog>
</template>

<script>
import PinPad from './PinPad.vue';

export default {
  name: 'PinModal',
  inheritAttrs: false,
  props: {
    validationErrors: {
      type: Array,
      default: () => []
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    isValidationRequired: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    open: {
      type: Boolean,
      default: false
    },
    shouldPinReset: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PinPad
  },
  data() {
    return {
      pinNumber: ''
    };
  },
  methods: {
    handleDialogUpdate(value) {
      if (!value) this.$emit('close-modal');
    },
    backspacePin() {
      this.pinNumber = this.pinNumber
        ? this.pinNumber.substr(0, this.pinNumber.length - 1)
        : '';
    },
    updatePin(num) {
      if (this.pinNumber.length === 4) return;
      this.pinNumber = `${this.pinNumber}${num}`;
      this.$emit('set-pin', this.pinNumber);
    }
  },
  watch: {
    shouldPinReset(newValue) {
      if (newValue) this.pinNumber = '';
      // this.updatePin('');
    },
    validationErrors(newErrors) {
      this.pinNumber = Object.keys(newErrors).length ? '' : this.pinNumber;
    }
  }
};
</script>

<style lang="scss">
.redeem-product {
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    border: 2px dashed black;
    top: -3px;
    left: 0;
    width: 100%;
  }

  &__modal {
    max-height: calc(100vh - 3rem);
    width: calc(100vw - 3rem);

    &--scale {
      transform: scale(0.75);
    }
  }
}
</style>

<style lang="scss" scoped>
.v-dialog {
    width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    width: 100%;
}
:deep(.v-overlay) {
  align-items: center;
  display: flex;
  justify-content: center;
  inset: 0;
  padding: 24px;
}

:deep(.v-overlay__content) {
  align-self: center;
  flex: 0 1 auto;
  margin: 0 auto;
  max-height: calc(100vh - 48px);
  max-width: min(480px, calc(100vw - 48px));
  position: relative;
  width: 100%;
  z-index: 2;
}
</style>

<style lang="scss">
.gps_modal .v-overlay__content,
.gps_modal__card {
  border-radius: 2rem !important;
  overflow: hidden;
}

.gps_modal {
  .v-overlay__content,
  &__card {
    max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    max-height: 95%;
    margin: 0;
  }
}
</style>
